import { typographyStyles, constants } from "@newsela/angelou";
const { ui } = constants.colors;
const { heading4Obj, textSObj } = typographyStyles;
import { CSSObject } from "@emotion/react";

export const subheadingCss: CSSObject = {
  textTransform: "uppercase",
  ...textSObj,
};

export const instructionsCss = {
  color: ui.neutral[500],
};

export const resourceBtnCss = {
  root: {
    marginBottom: "1em",
  },
};
export const titleCss = {
  width: "max-content",
  ...heading4Obj,
};

export const drawerContainerCss = {
  padding: "1em",
  borderTop: "none",
};
